import { motion } from "framer-motion";
import { Logo } from "../../../components/common/Logo";

/**
 * BoardLoader - Full board loading state
 * Shown when the board is first loading or completely updating
 * Uses the unified Dashbal logo loader for consistency
 */
export const BoardLoader: React.FC = () => {
  return (
    <div className="w-full h-full min-h-[500px] flex items-center justify-center">
      <div className="text-center">
        {/* Logo-based loader */}
        <div className="mb-6 flex justify-center">
          <div className="relative p-4">
            {/* Pulsing background glow */}
            <motion.div
              animate={{ scale: [1, 1.15, 1], opacity: [0.3, 0.5, 0.3] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              className="absolute inset-0 bg-accent-primary/20 rounded-full blur-xl"
            />

            {/* Spinning ring */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              className="absolute inset-0 m-auto w-20 h-20 rounded-full border-2 border-transparent border-t-accent-primary border-r-accent-primary/30"
            />

            {/* Logo with subtle pulse */}
            <motion.div
              animate={{ scale: [1, 1.05, 1] }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="relative z-10 flex items-center justify-center"
            >
              <Logo className="w-12 h-12 text-accent-primary" />
            </motion.div>
          </div>
        </div>

        {/* Loading Text */}
        <motion.h3
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-base font-semibold text-neutral-700 mb-2"
        >
          Loading Board
        </motion.h3>
        <motion.p
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="text-sm text-neutral-500"
        >
          Fetching your data...
        </motion.p>
      </div>
    </div>
  );
};
